import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ModalHeader,  Modal, ModalBody } from "reactstrap";
import Top from '../Top';
import Leftsiderbar from '../home/allcmp/Leftsidebar'
import { API_URL } from '../../../config';
import right from '../../images/right.png'


const AddTutorialCategory = () => {


  const [successModal, setsuccessModal] = useState(false);
  const successToggleModal = () => setsuccessModal(!successModal);

  const [recordingName, setRecordingName] = useState('');
  const { id } = useParams();
  const [recordingNameErr, setRecordingNameErr] = useState(true);
  const [statusFieldErr, setStatusFieldErr] = useState(true);
  const [errMessage ,setErrMessage] = useState('');
  const [statusField, setStatusField] = useState('')
  const navigate = useNavigate()
  useEffect(() => {
    if(id){
      getCategoryList();
    }

  }, [])

  const getCategoryList = () => {
    fetch(API_URL + "/get/category/by/" + id,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    ).then((response) => {
      if (response.status == 200) {
        response.json().then((resp) => {
          setRecordingName(resp.data[0].category_name)
          setStatusField(resp.data[0].status)

        });
      }
      else if (response.status == 401) {
        logout()
      }
      else {
        console.log("network error")
      }


    })
  }
  const createProfile = () => {
    if(isValid()){
    let data = {};
    data['category_name'] = recordingName;
    


    fetch(API_URL + "/add/tutorials/category", {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',

      },
      body: JSON.stringify(data)
    }).then((response) => {
      if (response.status == 200) {
        response.json().then((resp) => {
          successToggleModal();
          setTimeout(function(){navigate('/edit-tutorial-category') }, 5000);

        });
      }
      else if (response.status == 400) {
      }
      else if (response.status == 401) {
        logout()
      }
      else {
        console.log("network error")
      }


    })
  }else {
    return false
  }

  }
  const updateProfile = () => {
    if(isValid()){
    let data = {};
    data['category_name'] = recordingName;
    data['status'] = statusField;

    fetch(API_URL + "/update/category/by/" + id, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',

      },
      body: JSON.stringify(data)
    }).then((response) => {
      if (response.status == 200) {
        response.json().then((resp) => {
          successToggleModal();
          setTimeout(function(){navigate('/edit-tutorial-category') }, 5000);

        });
      }
      else if (response.status == 400) {
      }
      else if (response.status == 401) {
        logout()
      }
      else {
        console.log("network error")
      }


    })
  }else{
    return false
  }

  }
  const handleGoBack = () => {
    if(id){
    navigate('/edit-tutorial-category');
    }else{
      navigate('/tutorial-recordings');

    }
  }
  const isValid = ()=>{
    if(recordingName.trim()== ''){
      setRecordingNameErr(true);
      setStatusFieldErr(false);
      setErrMessage("Field required")
      return false
    }
    else if(id && statusField == ''){
      setRecordingNameErr(false);
      setStatusFieldErr(true);
      setErrMessage("Field required")
      return false
    }
    else{
      return true
    }
  }

  return (
    <div>
      <div className="cmail">
        <Top />
      </div>
      <div className="wrp-dashbord">
        <div className="cemail-left">
          <Leftsiderbar />
        </div>
        <div className="right-section ">
        <div className="head-listing head-listingb">
                            <h3>{id ? "Tutorial Categories":"Upload Tutorial Category "}</h3>
                        </div>
          <div className='right-section-box'>

            <div className='col-lg-12'>
              <div className='row'>
                <div className='form-group col-lg-12 no-padding'>
                  <label className=' control-label'>Add Category Name* </label>
                  <input type="text" value={recordingName} onChange={(e) => setRecordingName(e.target.value)} className='client-input' placeholder='Enter Category Name' />
                  {recordingNameErr ? <div className='linkError'>{errMessage}</div>:""}
                </div>
                {id ? <div className='form-group col-lg-12 no-padding'>
                  <label className=' control-label'>
                  Status*</label>
                  <select value={statusField} onChange={(e)=>setStatusField(e.target.value)} className='client-input' placeholder='Choose Country'>
                    <option value="">Select Status</option>
                    <option value="1" selected={statusField == 1 ? "Selected": ''}>Active</option>
                    <option value="2" selected={statusField == 2 ? "Selected": ''}>Inactive</option>
                  </select>
                  {statusFieldErr ? <div className='linkError'>{errMessage}</div>:""}
                 </div>:''}
              </div>
            </div>
            <div className='col-lg-12'>
              <div className='row'>
                <div className='form-group col-lg-6 no-padding'>
                  <button type="button" className='btn btn-primary_d' onClick={handleGoBack}>Go Back</button>
                </div>
                <div className='form-group col-lg-6 no-padding'>
                  
                {id ?  <button type="submit" className='btn btn-primary_d' onClick={updateProfile}>Update
                  </button> :
                  <button type="submit" className='btn btn-primary_d' onClick={createProfile}>Create
                  </button>}
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>
      <Modal isOpen={successModal} toggle={successToggleModal} className="connect-box" centered={true}>
        <ModalHeader toggle={successToggleModal}><span className="ml-1 roititle font-weight-bold">Successfull</span></ModalHeader>
        <ModalBody>
          <div className="modal-p">
            <div className="right-circle"><img src={right} /></div>
            <h4>{id ? "Updated" : "Created"}</h4>
            <p>Category has been {id ? "updated" : "created"} successfully</p>
          </div>
        </ModalBody>

      </Modal>
    </div>
  );
};

export default AddTutorialCategory;
  
